import { useState } from "react";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { defaultTQC2060_R01Filter, useTQC2060_R01Store } from "./Store_TQC2060_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import useUiuxStore from "src/store/useUiuxStore";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { SearchSpacer } from "src/components/common/common";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";


	export const SearchSection_TQC2060_R01 = () => {

	const { TQC2060_R01Filter, setTQC2060_R01Filter } = useTQC2060_R01Store();
	const { compCdList, carModelList, equipmentCdList } = useCommonCodeStore();
	const { setCodeSearchModalProps } = useUiuxStore();
	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleEmpFoucsId = 'empNo_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'empNo',
			category: '시험자',
			focusId: handleEmpFoucsId,
			responseMapping: {
				empNo: 'empNo',
				empNm: 'empNm',
			},
			extraFilter: () => ({
				empNo: TQC2060_R01Filter.empNo || '',
				empNm: TQC2060_R01Filter.empNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: TQC2060_R01Filter,
		setEditData: setTQC2060_R01Filter,
		defaultData: defaultTQC2060_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'TQC2060_R01_search'
	});
	
	// 시험기기 옵션 변환 (IsCodeDtoArray가 인식할 수 있도록 majorCd 추가)
	const equipmentOptions: SysCodeDto[] = equipmentCdList.map(equipment => ({
		majorCd: 'EQMTYPE',  // IsCodeDtoArray가 인식하기 위해 필요
		minorCd: equipment.equipmentCd,
		codeNm: equipment.equipmentNm
	} as SysCodeDto));

	return (
		<div className="w-full ">
				<SearchSectionDoubleForm >
				<SearchDropDownForm<CompanyDto>
				label="사업장"
				value={TQC2060_R01Filter.compCd}
				optionList={compCdList}
				onChangeValue={(v) => setTQC2060_R01Filter({ compCd: v === 'all' ? '' : v })}
				/>
				<SearchDateRangeForm
				label="시험기간"
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={TQC2060_R01Filter.testDt}
				setDateRange={(v) => setTQC2060_R01Filter({ testDt: v })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
				/>
				<SearchCodeModalForm
				label="시험자"
				value={TQC2060_R01Filter.empNo}
				valueLabel={TQC2060_R01Filter.empNm}
				handleFoucsId={handleEmpFoucsId}
				onChange={getFieldHandlers('empNo').onChange}
				onDoubleClick={getFieldHandlers('empNo').onDoubleClick}
				onKeyDown={getFieldHandlers('empNo').onEnterKeyDown}
				/>
				<SearchSpacer />
				<SearchDropDownForm<SysCodeDto>
				label="차종"
				value={TQC2060_R01Filter.carModel}
				optionList={carModelList}
				onChangeValue={(v) => setTQC2060_R01Filter({ carModel: v === 'all' ? '' : v })}
				/>
				<SearchDropDownForm<SysCodeDto>
				label="시험기기"
				value={TQC2060_R01Filter.equipmentCd}
				optionList={equipmentOptions}
				onChangeValue={(v) => setTQC2060_R01Filter({ equipmentCd: v === 'all' ? '' : v })}
				/>
			</SearchSectionDoubleForm>
	</div> );
	};

	export default SearchSection_TQC2060_R01;